'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.array.includes.js
// module id = 750
// module chunks = 0